/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ yearly_price_month: NonNullable<unknown>, view_all_plans: NonNullable<unknown> }} Relax_Paywall_Purchase_Footer_CnaInputs */

const en_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, No auto-renewal. ${i?.view_all_plans}`)
};

const ar_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, No auto-renewal. ${i?.view_all_plans}`)
};

const de_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, No auto-renewal. ${i?.view_all_plans}`)
};

const es_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, No auto-renewal. ${i?.view_all_plans}`)
};

const fr_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, No auto-renewal. ${i?.view_all_plans}`)
};

const it_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, No auto-renewal. ${i?.view_all_plans}`)
};

const ja_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, No auto-renewal. ${i?.view_all_plans}`)
};

const ko_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, No auto-renewal. ${i?.view_all_plans}`)
};

const pt_br_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, No auto-renewal. ${i?.view_all_plans}`)
};

const ru_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, No auto-renewal. ${i?.view_all_plans}`)
};

const th_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, No auto-renewal. ${i?.view_all_plans}`)
};

const tr_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equals ${i?.yearly_price_month}/month, No auto-renewal. ${i?.view_all_plans}`)
};

const zh_cn_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相当于 ${i?.yearly_price_month}/月，不会自动续费。${i?.view_all_plans}`)
};

const zh_tw_relax_paywall_purchase_footer_cna = /** @type {(inputs: Relax_Paywall_Purchase_Footer_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相当于 ${i?.yearly_price_month}/月，不会自动续费。${i?.view_all_plans}`)
};

/**
* | output |
* | --- |
* | "Equals {yearly_price_month}/month, No auto-renewal. {view_all_plans}" |
*
* @param {Relax_Paywall_Purchase_Footer_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const relax_paywall_purchase_footer_cna = /** @type {((inputs: Relax_Paywall_Purchase_Footer_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relax_Paywall_Purchase_Footer_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relax_paywall_purchase_footer_cna(inputs)
	if (locale === "ar") return ar_relax_paywall_purchase_footer_cna(inputs)
	if (locale === "de") return de_relax_paywall_purchase_footer_cna(inputs)
	if (locale === "es") return es_relax_paywall_purchase_footer_cna(inputs)
	if (locale === "fr") return fr_relax_paywall_purchase_footer_cna(inputs)
	if (locale === "it") return it_relax_paywall_purchase_footer_cna(inputs)
	if (locale === "ja") return ja_relax_paywall_purchase_footer_cna(inputs)
	if (locale === "ko") return ko_relax_paywall_purchase_footer_cna(inputs)
	if (locale === "pt_br") return pt_br_relax_paywall_purchase_footer_cna(inputs)
	if (locale === "ru") return ru_relax_paywall_purchase_footer_cna(inputs)
	if (locale === "th") return th_relax_paywall_purchase_footer_cna(inputs)
	if (locale === "tr") return tr_relax_paywall_purchase_footer_cna(inputs)
	if (locale === "zh_cn") return zh_cn_relax_paywall_purchase_footer_cna(inputs)
	return zh_tw_relax_paywall_purchase_footer_cna(inputs)
});